import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import ArrowIcon from '../../assets/svgs/ArrowIcon';
import LoadingSection from '../../components/Loading/LoadingSection';

import Api from '../../libs/Api';
import translate from '../../libs/i18n';
import { WebVisualizerDensitometryStyle } from './WebVisualizerDensitometryStyle';

const WebVisualizerDensitometry = ({ modal, report, pdf }) => {
  const [loading, setLoading] = useState(true);
  const language = useSelector((state) => state.settings.language);
  const [densitometryPDF, setDensitometryPDF] = useState(null);
  const [errorDensitometryPDF, setErrorDensitometryPDF] = useState(false);

  useEffect(() => {
    (async () => {

      if(pdf && Object.keys(pdf).length > 0){
        setDensitometryPDF(pdf);
        setLoading(false);
        return;
      }

      if (report?.id) {
        console.log('report', report);
        try{
          const responseDensitometry = await Api.getPDFDensitometriaById(report?.id);
          console.log('responseDensitometry', responseDensitometry);  

          if (responseDensitometry?.status === 200 && responseDensitometry?.data) {
            const pdfUrl = URL.createObjectURL(new Blob([responseDensitometry?.data], { type: 'application/pdf' }));
            setDensitometryPDF(pdfUrl);
          } else {
            setErrorDensitometryPDF(true);
          }
        } catch{
          setErrorDensitometryPDF(true);
        }

        setLoading(false);
      }
    })();
  }, [report, pdf]);

  return (
    <WebVisualizerDensitometryStyle>
      {!modal ? (
        <div>
          <div className="back-div">
            <Link to={`/relatorios/${id}`} className="back-link">
              <span className="icon">
                <ArrowIcon />
              </span>
              {translate('back', language)}
            </Link>
          </div>
        </div>
      ) : null}

      {errorDensitometryPDF ?
        <div className={modal ? 'web-visualizer-modal-container' : 'web-visualizer-container'}>
          <div className="alert alert-danger" role="alert">
              {translate('ohifError', language)}
          </div>
        </div> 
      : null}

      {densitometryPDF ? (
        <div className={modal ? 'web-visualizer-modal-container' : 'web-visualizer-container'}>
          <iframe
            id="my-iframe"
            title="Visualização do estudo"
            src={densitometryPDF}
            width="100%"
            height="100%"
          />
        </div>
      ) : null}

      {( loading ? <LoadingSection message={translate('loadingPDF', language)} /> : null )}

    </WebVisualizerDensitometryStyle>
  );
};

WebVisualizerDensitometry.propTypes = {
  modal: PropTypes.bool,
  report: PropTypes.any,
  pdf: PropTypes.any,
};

WebVisualizerDensitometry.defaultProps = {
  modal: false,
  report: {},
  pdf: {},
};

export default WebVisualizerDensitometry;
